import { GarmentSizesSorted } from '@gelato-api-ui/core/garment/garment-sizes-sorted';
import { SanityProductControlOption } from '@gelato-api-ui/core/sanity/sanity-product-control-option';

export const getSortedGarmentSizeControlOptions = (
  controlOptions: SanityProductControlOption[],
): SanityProductControlOption[] =>
  GarmentSizesSorted.map((loopGarmentSize: string) =>
    controlOptions.find((loopOption: SanityProductControlOption) => loopOption.value === loopGarmentSize),
  ).filter((loopOption: SanityProductControlOption) => Boolean(loopOption));
